import { ReactNode } from 'react';

import CleanButton from '../../../../../components/CleanButton/CleanButton';
import IconInCircle from '../../../../../components/IconInCircle/IconInCircle';
import Inline from '../../../../../components/Inline/Inline';
import Text from '../../../../../components/Text/Text';

import icon from './graphics/filter.svg?raw';

type FilterToggleProps = { children: ReactNode; onClick?: () => void };

const FilterToggle = ({ children, onClick }: FilterToggleProps) => {
    return (
        <CleanButton onClick={onClick}>
            <Inline vertical="middle" space="small">
                <IconInCircle src={icon} size="large" />
                <Text bold lineHeight="small">
                    {children}
                </Text>
            </Inline>
        </CleanButton>
    );
};

export default FilterToggle;
